import type { FetchUserParams } from "./useFetchUser";
import type { AutoCompleteUserParams } from "./useAutoCompleteUser";

export const userKeys = {
  all: ["users"] as const,
  lists: () => [...userKeys.all, "list"] as const,
  list: (params?: FetchUserParams) => [...userKeys.lists(), params ?? {}] as const,
  details: () => [...userKeys.all, "detail"] as const,
  detail: (id: number) => [...userKeys.details(), id] as const,
  // Aggregate "/api/users/:id/detail" bundle (hr info, personal data, bank
  // details, emergency contacts, equipment, salary). Nested under detail(id)
  // so that invalidating detailInfo(id) also invalidates the narrower
  // sub-resource branches below, since they're descendants of this key.
  detailInfo: (id: number) => [...userKeys.detail(id), "info"] as const,
  autocomplete: () => [...userKeys.all, "autocomplete"] as const,
  autocompleteList: (params?: AutoCompleteUserParams) =>
    [...userKeys.autocomplete(), params ?? {}] as const,
  bankDetails: (userId: number) => [...userKeys.detailInfo(userId), "bank-details"] as const,
  emergencyContacts: (userId: number) =>
    [...userKeys.detailInfo(userId), "emergency-contacts"] as const,
  equipments: (userId: number) => [...userKeys.detailInfo(userId), "equipments"] as const,
  hrInfo: (userId: number) => [...userKeys.detailInfo(userId), "hr-info"] as const,
  personalData: (userId: number) => [...userKeys.detailInfo(userId), "personal-data"] as const,
  supervisors: (userId: number) => [...userKeys.detailInfo(userId), "supervisors"] as const,
};
